export enum ProjectActions {
  SetActive = "Set active category",
  SelectAttr = "Select attribute",
  SetZoom = "Set zoom",
  ToggleFlip = "Toggle flip",
  Center = "Center",
  ChangeWall = "Change wall",
  Reset = "Reset",
  AddProjectToCart = "Add project to cart",
  ChangeProjectCount = "Change project count",
  DeleteCart = "Delete cart",
  LoadHistory = "Load history",
  LoadCart = "Load cart",
  SetLoaded = "Set loaded",
  LoadProject = "Load project",
  SearchDist = "Search distributors",
  SelectDist = "Select distributor",
  LoadDist = "Load distribiutors",
  SetForm = "Set form",
  RemoveDist = "Remove distributor",
  SetAttributes = "Set attributes",
  UpdateHistory = "Update history",
  UpdateCart = "Update cart",
  SetServices = "Set services",
  RemoveCart = "Remove cart",
  NextMenu = "Next menu",
  SetExpanded = "Set Expanded"
}
